<template>
    <ul class="channel-list">
        <!-- <transition-group name="fade-zoom"> -->
            <li v-for="channel in sortedChannels" :key="channel.id" v-loader="{ listen: `channel-${channel.id}` }">
                <component :is="channel.type === 'group' ? 'channel-list-group' : 'channel-list-single'"
                           :channel="channel"
                           :chat-states="unreadChats"
                />
            </li>
        <!-- </transition-group> -->
    </ul>
</template>

<script>
import { mapState } from 'vuex'

export default
{
    name: 'ChannelList',

    data() {
        return {
            channels: []
        }
    },

    computed:
    {
        ...mapState({
            unreadChats: ({ chat }) => chat.unreadChats
        }),

        unreadCount()
        {
            return this.$store.getters['chat/countUnread']
        },

        sortedChannels()
        {
            return _.orderBy(this.channels, ['lastUpdated'], 'desc');
        }
    },

    created: function()
    {
        this.getChannels();
    },

    methods:
    {
        getChannels()
        {
            this.$http.silent().get('/api/channels').then(response =>
            {
                this.channels = response.data;
            });
        }
    },

    watch:
    {
        unreadCount()
        {
            this.getChannels();
        }
    }
}
</script>



// WEBPACK FOOTER //
// ChannelList.vue?4402b15b